export class FindAllPagesAction {
  public static readonly type = '[Project/Wiki/List] FindAllPagesAction';
}
